import { render, staticRenderFns } from "./interactive-item-placeholder.vue?vue&type=template&id=6bb4d030&scoped=true&"
import script from "./interactive-item-placeholder.vue?vue&type=script&lang=js&"
export * from "./interactive-item-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./interactive-item-placeholder.vue?vue&type=style&index=0&id=6bb4d030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4d030",
  null
  
)

export default component.exports